import { useQuery } from '@tanstack/react-query';
import { encodeDateForUrl } from '../utils/dateUtils';
import driverAllocationAPI from '../api/driverAllocationAPI';
import { IOperationalBusDetail } from '../interfaces/operationBusDetail';
import { IPaxDriverAllocation } from '../interfaces/driverPaxAllocation';

interface AllocationDetailsResponse {
  operationDetails: {
    busDetails: IOperationalBusDetail[];
    totalAllocatedPax: number;
  };
  bookings: IPaxDriverAllocation[];
  totalPax: number;
}

// Custom hook
export const usePickupAllocationDetails = (date: Date, ownerId: number) => {
  const encodedDate = encodeDateForUrl(date);

  return useQuery<AllocationDetailsResponse>({
    queryKey: ['pickupAllocationDetails', ownerId, encodedDate],
    queryFn: async () => {
      const response = await driverAllocationAPI.getDriverPickupAllocation(
        ownerId,
        encodedDate,
      );
      return response.data;
    },
    enabled: !!date && !!ownerId,
  });
};
